import { LoaderService } from './../loder_service/loader.service';
import { DataService } from './../../app/data.service';
import { ActivatedRoute, Router,NavigationExtras } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-makuplist',
  templateUrl: './makuplist.component.html',
  styleUrls: ['./makuplist.component.scss'],
})
export class MakuplistComponent implements OnInit {
  cat_id:any;
  location_id:any;
 paramsData:any;
 serviceArray:any;
  constructor(public router:Router, public restApi:DataService, public toastService:LoaderService, public route:ActivatedRoute ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      //console.log(JSON.parse(params.sub_cat))
      this.paramsData=JSON.parse(params.sub_cat);
      //this.paramsData=JSON.parse(params.location_id);

    });
  }
ionViewWillEnter(){
  this.toastService.showLoader('')
 let postparams={
  cat_id:this.paramsData.sub_cat,
  location_id:this.paramsData.location_id
 }
 //alert(JSON.stringify(postparams))
 this.restApi.get_service_list(postparams).subscribe((data:any)=>{
   this.serviceArray=data.serviceArray;
   this.toastService.hideLoader();
 },(error:any)=>{
  this.toastService.hideLoader();
 })
}

makeupdetals(item){
  console.log(item.service_id);
  
  //routerLink="/makuplist"
  //this.router.navigate(['/location'])
  let navigationExtras: NavigationExtras = {
    queryParams: {
      location_id: JSON.stringify(this.paramsData.location_id),
      service_id: JSON.stringify(item.service_id),
      
    }
    
  };
  this.router.navigate(['/makupdetails'], navigationExtras);
}
}
